import { render, staticRenderFns } from "./IRPeoplePage.vue?vue&type=template&id=5fd4d598"
import script from "./IRPeoplePage.vue?vue&type=script&lang=js"
export * from "./IRPeoplePage.vue?vue&type=script&lang=js"
import style0 from "./IRPeoplePage.vue?vue&type=style&index=0&id=5fd4d598&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports